import React, { Component } from 'react';
import classnames from 'classnames';
import MainContent from "./MainContent";
import withSearchLogic from "./withSearchLogic";
import { InstantSearch } from "react-instantsearch-dom";
import { isEmpty } from 'lodash';
import Map from "./Map";
import ImageDrop from "./ImageDrop";

import PropTypes from "prop-types";

class App extends Component {
    state = {
        search: this.props.urlToSearchState(this.props.location),
        queryString: '',
        showMap: this.getCookie('il_show_map') === 'true',
    }

    componentDidMount() {

    }

    componentDidUpdate(prevProps, prevState) {
        // change state when user goes back and url changes.
        const nextSearchState = this.props.urlToSearchState(this.props.location);
        const locationState = { ...this.props.location.state };

        // console.log('prevProps:', prevProps);
        // console.log('prevState:', prevState);

        if (
            this.props.location.state
            && JSON.stringify(this.cleanObject(locationState)) !== JSON.stringify(this.cleanObject(this.state.search))
        ) {
            // console.log(JSON.stringify(this.cleanObject(locationState)));
            // console.log(JSON.stringify(this.cleanObject(this.state.search)));
            this.setState({
                search: nextSearchState,
            });
        };


        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    }

    // Autocomplete Addition
    onPressEnter = (value, shouldSubmit) => {
        let newSearchState = { ...this.state.search };

        newSearchState.query = value;
        newSearchState.page = 1;

        this.onSearchStateChange(newSearchState);
    }

    getCookie(name) {
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${name}=`);
        if (parts.length === 2) return parts.pop().split(';').shift();
    }

    cleanObject(obj) {
        let newObj = { ...obj };
        delete newObj.configure;
        for (var propName in newObj) {
            if (typeof newObj[propName] === 'object' && isEmpty(newObj[propName])) {
                delete newObj[propName];
            }
        }
        return newObj
    }

    onSearchStateChange = updatedSearchState => {
        const { searchStateToUrl, history } = this.props;

        for (const property in updatedSearchState.refinementList) {
            if (updatedSearchState.refinementList[property] === "") {
                updatedSearchState.refinementList[property] = [];
            }
        }

        history.push(searchStateToUrl(updatedSearchState), updatedSearchState);

        this.setState({
            search: updatedSearchState
        });
    };

    onSuggestionSelected = (hit, section) => {
        let newSearchState = { ...this.state.search };
        let type = section.title;

        newSearchState.page = 1;

        if (type === 'locations') {
            window.open(`${window.location.origin}/${hit.suggestion.slug}`);
        } else {
            newSearchState.query = "";
        }
        if (type === 'images') {
            newSearchState.query = hit.suggestion.value;
        }
        if (type === 'categories') {
            newSearchState.refinementList.categories.push(hit.suggestion.value);
        }
        if (type === 'permits') {
            newSearchState.refinementList.permit.push(hit.suggestion.value);
        }
        if (type === 'cities') {
            newSearchState.refinementList.city.push(hit.suggestion.value);
        }

        let url = this.props.searchStateToUrl(newSearchState);
        this.props.history.push(url, newSearchState);
        this.setState({
            search: newSearchState,
            queryString: url,
        });
    };

    onSetShowMapChange = e => {
        document.cookie = `il_show_map=${!this.state.showMap}`;
        this.setState({ showMap: !this.state.showMap });
    }

    render() {

        return (
            <>
                <div className="px-3">
                    <ImageDrop imagePreview={null} handleImageDrop={e => { console.log('test') }} />
                </div>

                <InstantSearch
                    searchClient={this.props.searchClient}
                    indexName="il_laravel_locations"
                    searchState={this.state.search}
                    onSearchStateChange={this.onSearchStateChange}
                    createURL={this.props.createURL}
                >
                    {/* <Configure hitsPerPage={15} /> */}
                    <div className={classnames('mb-5 container-fluid', !this.props.withMap ? 'no-map' : null)} >
                        <div className="row">
                            <div className={classnames(!!this.props.withMap && this.state.showMap ? 'col-lg-9 px-0' : 'col-12 px-0')}>
                                {!!this.props.withMap && (
                                    <div className="custom-control custom-checkbox px-3 py-2 text-right">
                                        <input
                                            type="checkbox"
                                            name="show_map"
                                            className="custom-control-input"
                                            id="show_map"
                                            checked={this.state.showMap}
                                            onChange={this.onSetShowMapChange}
                                        />
                                        <label className="custom-control-label" htmlFor="show_map">Show Map</label>
                                    </div>
                                )}
                                <MainContent
                                    onPressEnter={this.onPressEnter}
                                    query={this.state.search.query}
                                    queryString={this.props.location.search}
                                    refinementList={this.state.search.refinementList}
                                    onSuggestionSelected={this.onSuggestionSelected}
                                    index={this.props.index}
                                />
                            </div>
                            {!!this.props.withMap && this.state.showMap && (
                                <div className="col-lg-3 position-sticky il-map-container">
                                    <Map />
                                </div>
                            )}
                        </div>
                    </div>

                </InstantSearch>
            </>
        );
    }
}

App.propTypes = {
    history: PropTypes.shape({
        push: PropTypes.func.isRequired
    }),
    location: PropTypes.object.isRequired
};

export default withSearchLogic(App);
